import { render } from "./App.vue?vue&type=template&id=d8bd2cca&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=d8bd2cca&lang=scss"

import exportComponent from "C:\\Data\\Dev\\Repos\\Wordminder\\src\\client\\wordminder\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__